import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SortableTree, { toggleExpandedForAll } from 'react-sortable-tree';
import CurriculumTreeWrapper from './styled';

class CurriculumTree extends Component {
    static propTypes = {
        masterCourse: PropTypes.shape({
            tree: PropTypes.object.isRequired,
            spineNodes: PropTypes.array,
            id: PropTypes.string
        }),
        expandTree: PropTypes.bool,
        hasColumnExpand: PropTypes.bool
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props !== nextProps || this.state !== nextState) {
            return true;
        }
        return false;
    }

    constructor(props) {
        super(props);
        this.CurriculumTree = React.createRef();
        this.state = {
            treeData: []
        };
        this.treeData = [];
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.masterCourse.id && this.treeData.length === 0) {
            this.setState({ treeData: nextProps.masterCourse.tree.node || [] });
            this.treeData = nextProps.masterCourse.tree.nodes;
        }

        if (this.props.masterCourse.id !== nextProps.masterCourse.id) {
            this.setState({ treeData: nextProps.masterCourse.tree.node || [] });
            this.treeData = nextProps.masterCourse.tree.nodes;
        }
        if (!nextProps.hasColumnExpand) {
            this.toggleAllNodes(nextProps.expandTree);
        }
    }

    componentWillUnmount() {
        this.state = { treeData: [] };
        this.props.masterCourse.id = '';
    }

    handleOnChange(treeData) {
        this.treeData = treeData;
        this.setState({ treeData });
    }

    toggleAllNodes(expandTree) {
        this.treeData = toggleExpandedForAll({
            treeData: this.treeData,
            expanded: expandTree
        });
    }

    render() {
        return (
            <CurriculumTreeWrapper>
                <SortableTree
                    canDrag={false}
                    onChange={this.handleOnChange}
                    ref={this.CurriculumTree}
                    treeData={this.treeData}
                />
            </CurriculumTreeWrapper>
        );
    }
}

export default CurriculumTree;



// WEBPACK FOOTER //
// ./app/components/curriculum-tree/index.js